import { useEffect } from 'react';

export const useWebSecurityStatusData = getWebSecurityStatusRequest => {
    useEffect(() => {
        const timer = setInterval(() => getWebSecurityStatusRequest(), 2.7e6);

        return () => clearInterval(timer);
    }, []);
};
